module.exports = __webpack_public_path__ + "img/报告查询.svg";